import { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ListMyOrg from "./ListMyOrg";
import ListSharedOrg from "./ListSharedOrg";
import ListPageOrg from "./ListPageOrg";
import { useAtom } from 'jotai';
import { userACRoles } from "~/stores/UserStore";
import { AC_TLGeo_Role } from "~/common/typescript/services/access_control/AC_Tlgeo";
import { UI_ScreenStyles } from "../UI_ScreenStyles";
import { createBreadcrumbItems, commonBreadcrumbs } from "~/utils/breadcrumbUtils";

const OrganizationScreen = () => {
  const { t } = useTranslation();

  const [roles, setRoles] = useAtom(userACRoles);
  return (
    <UI_ScreenStyles.UI_Wrapper>
      <UI_ScreenStyles.UI_Breadcrumb
        items={createBreadcrumbItems([
          commonBreadcrumbs.home,
          { title: 'Doanh nghiệp', icon: commonBreadcrumbs.organizations.icon }
        ])}
      />

      <UI_ScreenStyles.UI_Content_Wrapper>
        {
          roles.includes(AC_TLGeo_Role.TLGEO_ADMIN) && (
            <div style={{ marginBottom: 20 }}>
              <ListPageOrg />
            </div>
          )
        }
        <div style={{ marginBottom: 20 }}>
          <ListMyOrg />
        </div>
        <div style={{ marginBottom: 20 }}>
          <ListSharedOrg />
        </div>
      </UI_ScreenStyles.UI_Content_Wrapper>
    </UI_ScreenStyles.UI_Wrapper>
  )
}

export default memo(OrganizationScreen);
